<template>
  <div class="presessionBox " :class="type == 'green' ? 'greenPresessionBox' : 'blueBox'">
    <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
      <v-col cols="12" lg="10" class="">
        <div class="d-flex" :class="$vuetify.breakpoint.mdAndDown && ' flex-column text-center'">
          <div>
            <img
                :src="type == 'green' ? require('../../assets/image/user-journey/presssion.svg') : require('../../assets/image/user-journey/presession_blue.svg')"
                alt="">
          </div>
          <div class="mr-4 d-flex flex-column justify-center">
            <div class="titlePresession ">
              {{ text }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="d-flex justify-center flex-column">
            <router-link :to="{name:'newPresession'}">
              <div class="presessionBtn" :class="type == 'green' ? 'presessionBtnGreen' : 'presessionBtnBlue'">
                رزرو جلسه ارزیابی رایگان
              </div>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
    <template v-else>
      <div class="d-flex" :class="$vuetify.breakpoint.mdAndDown && ' flex-column text-center'">
        <div>
          <img
              :src="type == 'green' ? require('../../assets/image/user-journey/presssion.svg') : require('../../assets/image/user-journey/presession_blue.svg')"
              alt="">
        </div>
        <div class="mr-4 d-flex flex-column justify-center">
          <div class="titlePresession ">
            {{ text }}
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex justify-center flex-column">
          <router-link :to="{name:'newPresession'}">
            <div class="presessionBtn" :class="type == 'green' ? 'presessionBtnGreen' : 'presessionBtnBlue'">
              رزرو جلسه ارزیابی رایگان
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PreSessionBox',
  props: {
    text: String,
    type: {
      default: 'green',
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

@media (min-width: 200px) and (max-width: 1000px) {
  .presessionBtn {
    margin-top: 20px;
  }

  .titlePresession {
    font-size: 16px !important;
  }
}

.presessionBtn {

  border-radius: 8px;
  background: white;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 20px;
}

.presessionBtnGreen {
  color: rgba(57, 201, 144, 1);
  border: 1px solid rgba(57, 201, 144, 1);
}

.presessionBtnBlue {
  color: rgba(3, 81, 132, 1);
  border: 1px solid rgba(3, 81, 132, 1);
}


.presessionBtn:hover {
  background: rgba(0, 0, 0, 0.01);
  transition: all 0.3s;
}

.titlePresession {
  font-weight: 600;
  font-size: 18px;
}

.contentPresession {
  font-weight: 500;
  font-size: 16px;
}

.presessionBox {
  border-radius: 8px;
  padding: 16px;
}

.greenPresessionBox {
  background: rgba(215, 244, 233, 0.5);

}

.blueBox {
  background: rgba(197, 239, 254, 0.35);
}
</style>


